import { render, staticRenderFns } from "./TakeOut.vue?vue&type=template&id=72c64818&scoped=true&"
import script from "./TakeOut.vue?vue&type=script&lang=js&"
export * from "./TakeOut.vue?vue&type=script&lang=js&"
import style0 from "./TakeOut.vue?vue&type=style&index=0&id=72c64818&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c64818",
  null
  
)

export default component.exports